export default __webpack_public_path__ + "squareLight.svg";